(function() {
  'use strict';

  angular
    .module('storytellingDemo', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'restangular', 'ui.router', 'ngMaterial', 'toastr', 'ngDialog']);

})();

(function(){
  'use strict';

  angular
    .module('storytellingDemo')
    .component('treemapEsquinado', treemapEsquinado());

  function treemapEsquinado() {
    return {
      templateUrl: 'app/components/treemapEsquinado/treemapEsquinado.html',
      controller: treemapEsquinadoController,
      controllerAs: 'vm',
      bindToController: true,
      bindings: { 
        ngModel: '=',
        disabled: '=',
        onload: '&',
        mode: '<',
        other: '<'
      }
    };
  }

  /* @ngInject */
  function treemapEsquinadoController($element, d3) {
    var vm = this;
    vm.updateModel = updateModel;
    vm.element = d3.select($element[0]).select('.treemap');
    vm.element.selectAll('*').remove();
    var originalWidth = vm.element.node().offsetWidth;
    var width = originalWidth;
    vm.svg = vm.element.append('svg')
      .attr('height', width)
      .attr('width', width)
      .append('g');

    d3.csv('assets/data/impunidad_edos.csv', function(data) {
      vm.data = data;
      vm.ngModel = vm.data[0];
      updateModel();
    });

    vm.$onChanges = function(){
      updateModel();
    }
    /**
     * Draws treemap based on ngModel data
     * @author Blanca López <blanca.lopez@data4.mx>
     */
    function updateModel() {
      vm.svg.selectAll('*').remove();
      if(vm.mode && vm.other) {
        width = originalWidth * 0.8;
        vm.element.select('svg')
          .attr('width', width)
          .attr('height', width);
        var width1 = (vm.ngModel.delitos_si_denunciados / d3.max([vm.ngModel.delitos_si_denunciados, vm.other.delitos_si_denunciados]));

        vm.svg.append('rect')
          .attr('x', width * (1 - width1))
          .attr('y', width * (1 - width1))
          .attr('width', width * width1)
          .attr('height', width * width1)
          .attr('fill', '#1db7b6');

        var width2 = (vm.ngModel.delitos_si_denunciados / d3.max([vm.ngModel.delitos_si_denunciados, vm.other.delitos_si_denunciados])) * vm.ngModel.delitos_resueltos;

        vm.svg.append('rect')
          .attr('x', width * (1 - width2))
          .attr('y', width * (1 - width2))
          .attr('width', width - width * (1 - width2))
          .attr('height', width - width * (1 - width2))
          .attr('fill', '#e44c66');
        
      } else if(vm.ngModel) {
        width = originalWidth;
        vm.element.select('svg')
          .attr('width', width)
          .attr('height', width);
        vm.svg.append('rect')
          .attr('x',0)
          .attr('y',0)
          .attr('width', width)
          .attr('height', width)
          .attr('fill', '#333');
        
        vm.svg.append('rect')
          .attr('x',width * (1 - vm.ngModel.delitos_si_denunciados))
          .attr('y',width * (1 - vm.ngModel.delitos_si_denunciados))
          .attr('width', width - width * (1 - vm.ngModel.delitos_si_denunciados))
          .attr('height', width - width * (1 - vm.ngModel.delitos_si_denunciados))
          .attr('fill', '#1db7b6');
        
        
        vm.svg.append('rect')
          .attr('x',width * (1 - vm.ngModel.probabilidad_esclarecimiento))
          .attr('y',width * (1 - vm.ngModel.probabilidad_esclarecimiento))
          .attr('width', width - width * (1 - vm.ngModel.probabilidad_esclarecimiento))
          .attr('height', width - width * (1 - vm.ngModel.probabilidad_esclarecimiento))
          .attr('fill', '#e44c66');
      }
      vm.onload();
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('storytellingDemo')
    .component('ranking', ranking());

  function ranking() {
    return {
      templateUrl: 'app/components/ranking/ranking.html',
      controller: rankingController,
      controllerAs: 'vm',
      bindToController: true,
      bindings: {}  
    }
  }

  /* @ngInject */
  function rankingController($storytelling, $log, d3, $element, $q, $timeout) {
    var vm = this;
    vm.init = init;
    vm.element = d3.select($element[0]);
    
    $storytelling.scroll('#ranking .outer', 'rankingScrolling', 2, animate);

    vm.dynamicText = '1_ranking';
    vm.test = "assets/images/1_ranking.png";
    vm.lastTime = 0;

    function init() {
      vm.svg = vm.element.select('#chart');
      vm.states = vm.svg.selectAll('svg > g').filter(function (d) { return d3.select(this).attr('id') ? true : false; });
      vm.states.style('opacity', 0);
    }

    function animate() {
      $log.log('ranking', $storytelling.currentSlide);
      if($storytelling.currentBreakPoint == '#ranking .outer') {
        switch($storytelling.currentSlide) {
          case 0:
          case 1:
            if (Math.floor((new Date() - vm.lastTime) / 1000) < 10) {
              // get from variable
            } else {
              vm.states
                .style('opacity', 0)
                .attr('transform', 'translate(0, -100)')
                .transition()
                  .duration(200)
                  .delay(function (d, i) {
                    return i * 50;
                  })
                  .style('opacity', 1)
                  .attr('transform', 'translate(0,0)');
              vm.lastTime = new Date();
            }
            break;
        }
      } else {
        vm.dynamicText = '';
        vm.states.style('opacity', 0);
      }
    }

    function animateState(index) {
      vm.states.filter(function(d,i){ return i == index; })
        .attr('transform', 'translate(0, -100)')
        .style('opacity', 0)
          .transition()
          .duration(500)
            .attr('transform', 'translate(0,0)')
            .style('opacity', 1)
            .attr('fill', function(){ return index == 1 ? 'yellow' : null; })
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('storytellingDemo')
    .component('national', national());

  function national() {
    return {
      templateUrl: 'app/components/national/national.html',
      controller: nationalController,
      controllerAs: 'vm',
      bindToController: true,
      bindings: {}  
    }
  }

  /* @ngInject */
  function nationalController($storytelling, $log, d3, $element) {
    var vm = this;
    vm.init = init;
    vm.element = d3.select($element[0]);
    //init();
    $storytelling.scroll('#national .outer', 'nationalScrolling', 3, animate);
    

    function init() {
      var width = vm.element.select('.treemap').node().offsetWidth;
      vm.svg = vm.element.select('.treemap').append('svg')
        .attr('height', width)
        .attr('width', width)
        .append('g');

      vm.svg.append('rect')
        .attr('x', 0)
        .attr('y', 0)
        .attr('width', width)
        .attr('height', width)
        .attr('fill', '#ddd');

      vm.svg.append('rect')
        .attr('x', width * (1 - 0.066))
        .attr('y', width * (1 - 0.066))
        .attr('width', width - width * (1 - 0.066))
        .attr('height', width - width * (1 - 0.066))
        .attr('fill', '#1db7b6');


      vm.svg.append('rect')
        .attr('x', width * (1 - 0.036))
        .attr('y', width * (1 - 0.036))
        .attr('width', width - width * (1 - 0.036))
        .attr('height', width - width * (1 - 0.036))
        .attr('fill', '#e44c66');

      $storytelling.zoomTo(vm.svg, 'rect:nth-child(3)');
    }

    function animate() {
      $log.log('mapa', $storytelling.currentSlide)
      if($storytelling.currentBreakPoint == '#national .outer') {
        vm.currentSlide = $storytelling.currentSlide;
        switch($storytelling.currentSlide) {
          case 0:
            //$storytelling.zoomTo(vm.svg, '#national rect:nth-child(3)');
            break;

          case 1:
            //$storytelling.zoomTo(vm.svg, '#national rect:nth-child(2)');
            break;

          case 2:
            //$storytelling.zoomTo(vm.svg, '#national rect:nth-child(1)');
            break;
            
        }
      } 
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('storytellingDemo')
    .component('mpsPresupuesto', mpsPresupuesto());

  function mpsPresupuesto() {
    return {
      templateUrl: 'app/components/mpsPresupuesto/mpsPresupuesto.html',
      controller: mpsPresupuestoController,
      controllerAs: 'vm',
      bindToController: true,
      bindings: {}  
    }
  }

  /* @ngInject */
  function mpsPresupuestoController($storytelling, $log, d3, $element) {
    var vm = this;
    vm.init = init;
    vm.element = d3.select($element[0])

    $storytelling.scroll('#mpsPresupuesto .outer', 'mpsPresupuestoScrolling', 6, animate);

    vm.dynamicText = '1_mpsvspresupuesto';
    vm.test = "assets/images/1_mpsvspresupuesto.jpg";

    function init() {
      vm.element.select('#scatter #_x30_1').attr('display', null);
      vm.element.select('#scatter #_x30_2').attr('display', 'none');
      vm.element.select('#scatter #_x30_3-1').attr('display', 'none');
      vm.element.select('#scatter #_x30_3-2').attr('opacity', 0);
    }

    function animate() {
      $log.log('mpsPresupuesto', $storytelling.currentSlide)
      if($storytelling.currentBreakPoint == '#mpsPresupuesto .outer') {
        switch($storytelling.currentSlide) {
          case 0:
            vm.dynamicText = '1_mpsvspresupuesto';
            vm.test = "assets/images/1_mpsvspresupuesto.jpg";
            vm.element.select('#scatter #_x30_1').attr('display', null);
            vm.element.select('#scatter #_x30_2').attr('display', 'none');
            vm.element.select('#scatter #_x30_3-1').attr('display', 'none');
            vm.element.select('#scatter #_x30_3-2').attr('opacity', 0);
            vm.element.select('#scatter #_x30_3-2 #QROO').attr('display', null);
            vm.element.select('#scatter #_x30_3-2 #CHIH').attr('display', null);
            vm.element.select('#scatter #zoomqroo').attr('display', 'none');
            vm.element.select('#scatter #zoomchih').attr('display', 'none');

            break;

          case 1:
            vm.dynamicText = '2_mpsvspresupuesto';
            vm.test = "assets/images/2_mpsvspresupuesto.jpg";
            vm.element.select('#scatter #_x30_1').attr('display', null);
            vm.element.select('#scatter #_x30_2').attr('display', null);
            vm.element.select('#scatter #_x30_3-1').attr('display', 'none');
            vm.element.select('#scatter #_x30_3-2').attr('opacity', 0);
            vm.element.select('#scatter #_x30_3-2 #QROO').attr('display', null);
            vm.element.select('#scatter #_x30_3-2 #CHIH').attr('display', null);
            vm.element.select('#scatter #zoomqroo').attr('display', 'none');
            vm.element.select('#scatter #zoomchih').attr('display', 'none');
            $storytelling.animateD3('#scatter #_x30_2', 'fadeIn');
            
            break;

          case 2:
            vm.dynamicText = '3_mpsvspresupuesto';
            vm.test = "assets/images/3_mpsvspresupuesto.jpg";
            vm.element.select('#scatter #_x30_1').attr('display', null);
            vm.element.select('#scatter #_x30_2').attr('display', null);
            vm.element.select('#scatter #_x30_3-1').attr('display', null);
            vm.element.select('#scatter #_x30_3-2').attr('opacity', 0);
            vm.element.select('#scatter #_x30_3-2 #QROO').attr('display', null);
            vm.element.select('#scatter #_x30_3-2 #CHIH').attr('display', null);
            vm.element.select('#scatter #zoomqroo').attr('display', 'none');
            vm.element.select('#scatter #zoomchih').attr('display', 'none');
            $storytelling.animateD3('#scatter #_x30_3-1', 'fadeIn');
            break;

          case 3:
            vm.dynamicText = '3_mpsvspresupuesto';
            vm.test = "assets/images/3_mpsvspresupuesto.jpg";
            vm.element.select('#scatter #_x30_1').attr('display', null);
            vm.element.select('#scatter #_x30_2').attr('display', null);
            vm.element.select('#scatter #_x30_3-1').attr('display', null);
            vm.element.select('#scatter #_x30_3-2').attr('opacity', 1);
            vm.element.select('#scatter #_x30_3-2 #QROO').attr('display', null);
            vm.element.select('#scatter #_x30_3-2 #CHIH').attr('display', null);
            vm.element.select('#scatter #zoomqroo').attr('display', 'none');
            vm.element.select('#scatter #zoomchih').attr('display', 'none');
            $storytelling.animateD3('#scatter #_x30_3-2', 'fadeIn');
            break;

          case 4:
            // Highlight Queretaro
            vm.dynamicText = '3_mpsvspresupuesto';
            vm.test = "assets/images/3_mpsvspresupuesto.jpg";
            vm.element.select('#scatter #_x30_1').attr('display', null);
            vm.element.select('#scatter #_x30_2').attr('display', null);
            vm.element.select('#scatter #_x30_3-1').attr('display', null);
            vm.element.select('#scatter #_x30_3-2').attr('opacity', 0.5);
            vm.element.select('#scatter #_x30_3-2 #QROO').attr('display', 'none');
            vm.element.select('#scatter #_x30_3-2 #CHIH').attr('display', null);
            vm.element.select('#scatter #zoomqroo').attr('display', null);
            vm.element.select('#scatter #zoomchih').attr('display', 'none');
            vm.element.select('#scatter #zoomqroo > path').attr('fill', '#8d3c66');
            $storytelling.animateD3('#scatter #zoomqroo', 'fadeIn');
            break;
          
          case 5:
            // Highlight Chihuahua
            vm.dynamicText = '3_mpsvspresupuesto';
            vm.test = "assets/images/3_mpsvspresupuesto.jpg";
            vm.element.select('#scatter #_x30_1').attr('display', null);
            vm.element.select('#scatter #_x30_2').attr('display', null);
            vm.element.select('#scatter #_x30_3-1').attr('display', null);
            vm.element.select('#scatter #_x30_3-2').attr('opacity', 0.5);
            vm.element.select('#scatter #_x30_3-2 #QROO').attr('display', null);
            vm.element.select('#scatter #_x30_3-2 #CHIH').attr('display', 'none');
            vm.element.select('#scatter #zoomqroo').attr('display', 'none');
            vm.element.select('#scatter #zoomchih').attr('display', null);
            vm.element.select('#scatter #zoomchih > path').attr('fill', '#8d3c66');
            $storytelling.animateD3('#scatter #zoomchih', 'fadeIn');
            break;
            
        }
      } else {
        vm.dynamicText = '';
      }
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('storytellingDemo')
    .component('infancy', infancy());

  function infancy() {
    return {
      templateUrl: 'app/components/infancy/infancy.html',
      controller: infancyController,
      controllerAs: 'vm',
      bindToController: true,
      bindings: {}  
    }
  }

  /* @ngInject */
  function infancyController($storytelling, $log) {
    var vm = this;

    $storytelling.scroll('#infancy .outer', 'infancyScrolling', 3, animate);

    vm.dynamicText = '1_mpsvspresupuesto';
    vm.test = "assets/images/1_mpsvspresupuesto.jpg";

    function animate() {
      $log.log('mapa', $storytelling.currentSlide)
      if($storytelling.currentBreakPoint == '#infancy .outer') {
        switch($storytelling.currentSlide) {
          case 0:
            vm.dynamicText = '1_mpsvspresupuesto';
            vm.test = "assets/images/1_mpsvspresupuesto.jpg";
            break;

          case 1:
            vm.dynamicText = '2_mpsvspresupuesto';
            vm.test = "assets/images/2_mpsvspresupuesto.jpg";
            break;

          case 2:
            vm.dynamicText = '3_mpsvspresupuesto';
            vm.test = "assets/images/3_mpsvspresupuesto.jpg";
            break;
            
        }
      } else {
        vm.dynamicText = '';
      }
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('storytellingDemo')
    .component('efectividad', efectividad());

  function efectividad() {
    return {
      templateUrl: 'app/components/efectividad/efectividad.html',
      controller: efectividadController,
      controllerAs: 'vm',
      bindToController: true,
      bindings: {}  
    }
  }

  /* @ngInject */
  function efectividadController($storytelling, $log, $element, d3) {
    var vm = this;

    $storytelling.scroll('#grafica_efectividad .outer', 'efectividadScrolling', 3, animate);

    vm.dynamicText = '1_efectividad';
    vm.element = d3.select($element[0]);

    function animate() {
      $log.log('mapa', $storytelling.currentSlide)
      if($storytelling.currentBreakPoint == '#grafica_efectividad .outer') {
        switch($storytelling.currentSlide) {
          case 0:
            vm.element.select('#chart').style('width', '100%')
            vm.element.selectAll('p').style('display','none')
            vm.element.select('svg #RESTO_x5F_EDOS').style('opacity', 1);
            vm.element.select('svg #CHIS').style('opacity', 1);
            vm.element.select('svg #SLP').style('opacity', 1);
            vm.element.select('svg #VER').style('opacity', 1);
            vm.element.select('svg #DGO').style('opacity', 1);

            break;

          case 1:
            vm.element.select('#chart').style('width', '66%');
            vm.element.selectAll('p').style('display','block');
            vm.element.select('svg #RESTO_x5F_EDOS').style('opacity', 0.6);
            vm.element.select('svg #CHIS').style('opacity', 0.6);
            vm.element.select('svg #SLP').style('opacity', 0.6);
            vm.element.select('svg #VER').style('opacity', 1);
            vm.element.select('svg #DGO').style('opacity', 1);

            break;

          case 2:
            vm.element.select('#chart').style('width', '66%');
            vm.element.selectAll('p').style('display', 'block');
            vm.element.select('svg #RESTO_x5F_EDOS').style('opacity', 0.6);
            vm.element.select('svg #CHIS').style('opacity', 1);
            vm.element.select('svg #SLP').style('opacity', 1);
            vm.element.select('svg #VER').style('opacity', 0.6);
            vm.element.select('svg #DGO').style('opacity', 0.6);
            break;
            
        }
      } else {
        vm.dynamicText = '';
      }
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('storytellingDemo')
    .component('confianzaPresupuesto', confianzaPresupuesto());

  function confianzaPresupuesto() {
    return {
      templateUrl: 'app/components/confianzaPresupuesto/confianzaPresupuesto.html',
      controller: confianzaPresupuestoController,
      controllerAs: 'vm',
      bindToController: true,
      bindings: {}  
    }
  }

  /* @ngInject */
  function confianzaPresupuestoController($storytelling, $log, d3, $element) {
    var vm = this;
    vm.init = init;
    vm.element = d3.select($element[0]);
    
    $storytelling.scroll('#confianzaPresupuesto .outer', 'confianzaPresupuestoScrolling', 6, animate);

    vm.dynamicText = '1_confianzaPresupuesto';
    vm.test = "assets/images/1_confianzaPresupuesto.jpg";

    function init() {
      vm.element.select('#scatter #_x30_1').attr('display', null);
      vm.element.select('#scatter #_x30_2').attr('display', 'none');
      vm.element.select('#scatter #_x30_3-1').attr('display', 'none');
      vm.element.select('#scatter #_x30_3-2').attr('opacity', 0);
      vm.element.select('#scatter #_x30_3-2 #NL').attr('display', null);
      vm.element.select('#scatter #_x30_3-2 #MEX').attr('display', null);
      vm.element.select('#scatter #zoomNL').attr('display', 'none');
      vm.element.select('#scatter #zoomMEX').attr('display', 'none');
    }

    function animate() {
      $log.log('mapa', $storytelling.currentSlide)
      if($storytelling.currentBreakPoint == '#confianzaPresupuesto .outer') {
        switch($storytelling.currentSlide) {
          case 0:
            vm.element.select('#scatter #_x30_1').attr('display', null);
            vm.element.select('#scatter #_x30_2').attr('display', 'none');
            vm.element.select('#scatter #_x30_3-1').attr('display', 'none');
            vm.element.select('#scatter #_x30_3-2').attr('opacity', 0);
            vm.element.select('#scatter #_x30_3-2 #NL').attr('display', null);
            vm.element.select('#scatter #_x30_3-2 #MEX').attr('display', null);
            vm.element.select('#scatter #zoomNL').attr('display', 'none');
            vm.element.select('#scatter #zoomMEX').attr('display', 'none');
            break;

          case 1:
            vm.element.select('#scatter #_x30_1').attr('display', null);
            vm.element.select('#scatter #_x30_2').attr('display', null);
            vm.element.select('#scatter #_x30_3-1').attr('display', 'none');
            vm.element.select('#scatter #_x30_3-2').attr('opacity', 0);
            vm.element.select('#scatter #_x30_3-2 #NL').attr('display', null);
            vm.element.select('#scatter #_x30_3-2 #MEX').attr('display', null);
            vm.element.select('#scatter #zoomNL').attr('display', 'none');
            vm.element.select('#scatter #zoomMEX').attr('display', 'none');
            $storytelling.animateD3('#scatter #_x30_2', 'fadeIn');
            break;

          case 2:
            vm.element.select('#scatter #_x30_1').attr('display', null);
            vm.element.select('#scatter #_x30_2').attr('display', null);
            vm.element.select('#scatter #_x30_3-1').attr('display', null);
            vm.element.select('#scatter #_x30_3-2').attr('opacity', 0);
            vm.element.select('#scatter #_x30_3-2 #NL').attr('display', null);
            vm.element.select('#scatter #_x30_3-2 #MEX').attr('display', null);
            vm.element.select('#scatter #zoomNL').attr('display', 'none');
            vm.element.select('#scatter #zoomMEX').attr('display', 'none');
            $storytelling.animateD3('#scatter #_x30_3-1', 'fadeIn');
            break;
          
          case 3:
            vm.element.select('#scatter #_x30_1').attr('display', null);
            vm.element.select('#scatter #_x30_2').attr('display', null);
            vm.element.select('#scatter #_x30_3-1').attr('display', null);
            vm.element.select('#scatter #_x30_3-2').attr('opacity', 1);
            vm.element.select('#scatter #_x30_3-2 #NL').attr('display', null);
            vm.element.select('#scatter #_x30_3-2 #MEX').attr('display', null);
            vm.element.select('#scatter #zoomNL').attr('display', 'none');
            vm.element.select('#scatter #zoomMEX').attr('display', 'none');
            $storytelling.animateD3('#scatter #_x30_3-2', 'fadeIn');
            break;

          case 4:
            vm.element.select('#scatter #_x30_1').attr('display', null);
            vm.element.select('#scatter #_x30_2').attr('display', null);
            vm.element.select('#scatter #_x30_3-1').attr('display', null);
            vm.element.select('#scatter #_x30_3-2').attr('opacity', 0.7);
            vm.element.select('#scatter #_x30_3-2 #NL').attr('display', 'none');
            vm.element.select('#scatter #_x30_3-2 #MEX').attr('display', null);
            vm.element.select('#scatter #zoomNL').attr('display', null);
            vm.element.select('#scatter #zoomMEX').attr('display', 'none');
            $storytelling.animateD3('#scatter #zoomNL', 'fadeIn');
            break;

          case 5:
            vm.element.select('#scatter #_x30_1').attr('display', null);
            vm.element.select('#scatter #_x30_2').attr('display', null);
            vm.element.select('#scatter #_x30_3-1').attr('display', null);
            vm.element.select('#scatter #_x30_3-2').attr('opacity', 0.7);
            vm.element.select('#scatter #_x30_3-2 #NL').attr('display', null);
            vm.element.select('#scatter #_x30_3-2 #MEX').attr('display', 'none');
            vm.element.select('#scatter #zoomNL').attr('display', 'none');
            vm.element.select('#scatter #zoomMEX').attr('display', null);
            $storytelling.animateD3('#scatter #zoomMEX', 'fadeIn');
            break;
            
        }
      } else {
        vm.dynamicText = '';
      }
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('storytellingDemo')
    .component('cifraNegra', cifraNegra());

  function cifraNegra() {
    return {
      templateUrl: 'app/components/cifraNegra/cifraNegra.html',
      controller: cifraNegraController,
      controllerAs: 'vm',
      bindToController: true,
      bindings: {}  
    }
  }

  /* @ngInject */
  function cifraNegraController($storytelling, $log, $element, d3) {
    var vm = this;
    vm.init = init;
    vm.switchCifras = switchCifras;
    vm.element = d3.select($element[0]);
    $storytelling.scroll('#cifraNegra .outer', 'cifraNegraScrolling', 4, animate);

    vm.dynamicText = '1_cifraNegra';
    vm.svgUrl = "assets/images/svg/cifra_negra.svg";
    vm.delitos = true;  

    /**
     * Switch "cifra_negra" bars in last slide
     * @author Blanca López <blanca.lopez@data4.mx>
     */
    function switchCifras() {
      if(vm.delitos) {
        vm.element.select('svg #cifra_negra').attr('display', null);
        vm.element.select('svg #cifra_blanca_1_').attr('display', 'none');
      } else {
        vm.element.select('svg #cifra_negra').attr('display', 'none');
        vm.element.select('svg #cifra_blanca_1_').attr('display', null);
      }
    }
    
    /**
     * Runs when svg is loaded
     */
    function init() {
      vm.element.select('svg #datos').attr('display', null);
      vm.element.select('svg #base1').attr('display', null);
      vm.element.select('svg #base2').attr('display', null);
      vm.element.select('svg #PUE').attr('display', null);
      vm.element.select('svg #GRO').attr('display', null);
      vm.element.select('svg #BCS').attr('display', null);
      vm.element.select('svg #cifra_negra').attr('display', 'none');
      vm.element.select('svg #cifra_blanca_1_').attr('display', 'none');

      vm.element.select('svg #base1').style('opacity', 1);
      vm.element.select('svg #base2').style('opacity', 1);
      vm.element.select('svg #PUE').style('opacity', 1);
      vm.element.select('svg #GRO').style('opacity', 1);
      vm.element.select('svg #BCS').style('opacity', 1);
    }
    
    /**
     * Animate elements for each slide (runs when .outer component is scrolled)
     * @author Blanca López <blanca.lopez@data4.mx>
     */
    function animate() {
      $log.log('mapa', $storytelling.currentSlide)
      if($storytelling.currentBreakPoint == '#cifraNegra .outer') {
        vm.currentSlide = $storytelling.currentSlide; 
        switch($storytelling.currentSlide) {
          case 0:
            vm.element.select('svg #datos').attr('display', null);
            vm.element.select('svg #base1').attr('display', null);
            vm.element.select('svg #base2').attr('display', null);
            vm.element.select('svg #PUE').attr('display', null);
            vm.element.select('svg #GRO').attr('display', null);
            vm.element.select('svg #BCS').attr('display', null);
            vm.element.select('svg #cifra_negra').attr('display', 'none');
            vm.element.select('svg #cifra_blanca_1_').attr('display', 'none');

            vm.element.select('svg #base1').style('opacity', 1);
            vm.element.select('svg #base2').style('opacity', 1);
            vm.element.select('svg #PUE').style('opacity', 1);
            vm.element.select('svg #GRO').style('opacity', 1);
            vm.element.select('svg #BCS').style('opacity', 1);
            break;

          case 1:
            vm.element.select('svg #datos').attr('display', null);
            vm.element.select('svg #base1').attr('display', null);
            vm.element.select('svg #base2').attr('display', null);
            vm.element.select('svg #PUE').attr('display', null);
            vm.element.select('svg #GRO').attr('display', null);
            vm.element.select('svg #BCS').attr('display', null);
            vm.element.select('svg #cifra_negra').attr('display', 'none');
            vm.element.select('svg #cifra_blanca_1_').attr('display', 'none');

            vm.element.select('svg #base1').style('opacity', 0.4);
            vm.element.select('svg #base2').style('opacity', 0.4);
            vm.element.select('svg #PUE').style('opacity', 0.4);
            vm.element.select('svg #GRO').style('opacity', 0.4);
            vm.element.select('svg #BCS').style('opacity', 1);
            break;

          case 2:
            vm.element.select('svg #datos').attr('display', null);
            vm.element.select('svg #base1').attr('display', null);
            vm.element.select('svg #base2').attr('display', null);
            vm.element.select('svg #PUE').attr('display', null);
            vm.element.select('svg #GRO').attr('display', null);
            vm.element.select('svg #BCS').attr('display', null);
            vm.element.select('svg #cifra_negra').attr('display', 'none');
            vm.element.select('svg #cifra_blanca_1_').attr('display', 'none');

            vm.element.select('svg #base1').style('opacity', 0.4);
            vm.element.select('svg #base2').style('opacity', 0.4);
            vm.element.select('svg #PUE').style('opacity', 1);
            vm.element.select('svg #GRO').style('opacity', 1);
            vm.element.select('svg #BCS').style('opacity', 0.4);
            break;
         
          case 3:
            vm.element.select('svg #datos').attr('display', 'none');
            vm.element.select('svg #base1').attr('display', 'none');
            vm.element.select('svg #base2').attr('display', 'none');
            vm.element.select('svg #PUE').attr('display', 'none');
            vm.element.select('svg #GRO').attr('display', 'none');
            vm.element.select('svg #BCS').attr('display', 'none');
            vm.element.select('svg #cifra_negra').attr('display', null);
            vm.element.select('svg #cifra_blanca_1_').attr('display', 'none');
            break;
            
        }
      } else {
        vm.dynamicText = '';
      }
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('storytellingDemo')
    .component('adolescence', adolescence());

  function adolescence() {
    return {
      templateUrl: 'app/components/adolescence/adolescence.html',
      controller: adolescenceController,
      controllerAs: 'vm',
      bindToController: true,
      bindings: {}  
    }
  }

  /* @ngInject */
  function adolescenceController($storytelling, $log, $element, d3) {
    //var vm = this;
    $storytelling.scroll('#adolescence .outer', 'adolescenceScrolling', 2, animate);

    function animate() {
      $log.log('mapa', $storytelling.currentSlide)
      if($storytelling.currentBreakPoint == '#adolescence .outer') {
        switch($storytelling.currentSlide) {
          case 0:
            d3.select('#waldo')
              .style('background-position', '52% 0%')
              .style('background-size', '88%');
            break;

          case 1:
            d3.select('#waldo')
              .style('background-position', '62% 60%')
              .style('background-size', '303%');
            break;
            
        }
      } else {
        d3.select('#waldo')
          .style('background-position', '52% 0%')
          .style('background-size', '88%');
      }
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('storytellingDemo')
    .factory('$storytelling', storytelling);

  /* @ngInject */
  function storytelling(scrollWatcher, $timeout, $rootScope, $q, d3, $document){
    var vm = {};
    vm.currentBreakPoint  = 0;
    vm.currentSlide       = 0;
    vm.bpHasChanged       = false;
    vm.scroll             = initScroll;
    vm.animateElem        = animateElem;
    vm.animateD3          = animateD3;
    vm.zoomTo             = zoomTo;
    vm.resetZoom          = resetZoom;

    /** Init scroll behaviour on .outer and .inner divs
     * @param {string} parent - Name of parent to fixed scroll
     * @param {string} scrollVarName - Specifies name for scrolling accesor
     * @param {integer} slidesNumber - Number of slides outer will be devided by
     * @param {function} callback - Function that will be executed when slide changes
     */
    function initScroll(parent, scrollVarName, slidesNumber, callback) {
      vm[scrollVarName] = 0;
      $timeout(function(){
        scrollWatcher({
          parent: parent,
          onUpdate: function(scrollPercent, parentElement) {
            if(vm[scrollVarName] != scrollPercent) { // scrolling position has changed
              $rootScope.$apply(function(){
                vm[scrollVarName] = (vm[scrollVarName] != scrollPercent) ? scrollPercent : vm[scrollVarName];
                vm.currentBreakPoint = parentElement.selector;
                if(vm.currentSlide !== getSlide(101, 0, slidesNumber, vm[scrollVarName])) {
                  vm.currentSlide = getSlide(101, 0, slidesNumber, vm[scrollVarName]);
                  callback();
                }
              });
            }
          }
        });
      });
    }

    /**
     * Calculate slide number that has to be seen
     * @param {number} end - End percentage
     * @param {number} start - Start percentage
     * @param {number} slidesLength - Quantity of slides defined
     * @param {number} scrollPercent - Current scroll percentage
     */
    function getSlide(end, start, slidesLength, scrollPercent){
      if(slidesLength == 0) {
        return 0;
      }
      var mul = (end - start) / slidesLength;
      return Math.floor((scrollPercent - start) / mul);
    }

    /**
     * Animate element using jQuery functions and animatecss
     * @param {selector} element 
     * @param {string} animationName 
     */
    function animateElem(element, animationName){
      return $q(function(resolve) { //, reject) {
        var animationEnds = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        angular.element(element).addClass('animated ' + animationName).one(animationEnds, function(){
          angular.element(this).removeClass('animated undefined ' + animationName);
          resolve(true);
        });
      })
    }

    /**
     * Animate elements using D3 and animatecss. It will replace ALL classes
     * @param {selector} element 
     * @param {string} animationName 
     */
    function animateD3(element, animationName) {
      return $q(function(resolve) { //} reject) {
        d3.selectAll(element).attr('class', null);
        d3.selectAll(element)
          .attr('class', 'animated ' + animationName)
          .on('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            d3.selectAll(element).attr('class', null);
            resolve(true);
          });
      });
    }

    /**
     * Resets group element (SVG) xoom to 0,0 and scale 1
     * @param {d3 selection} groupElement 
     */
    function resetZoom(groupElement) {
      groupElement.transition()
        .duration(500)
        .attr('transform', 'translate(0,0) scale(1)')
    }

    /**
     * Zoom group element (SVG) to calculated position of selector
     * Results may vary according to SVG properties
     * @param {d3 selection} groupElement 
     * @param {string selector} selector 
     */
    function zoomTo(groupElement, selector) {
      if(groupElement && selector && $document[0].querySelector(selector)) {
        $timeout(function(){
          
          //var transform = 'translate(0,0)scale(1)';
          //groupElement.attr('transform', null);
          
          var clientRect = $document[0].querySelector(selector).getBoundingClientRect();
          var bbox = angular.element(selector)[0].getBBox();
          var svg = groupElement._groups[0][0].parentNode.getBoundingClientRect();
          var data = {
              x: +d3.select(selector).attr('x') || bbox.x,
              y: +d3.select(selector).attr('y') || bbox.y,
              width: +d3.select(selector).attr('width') || clientRect.width,
              height: +d3.select(selector).attr('height') || clientRect.height,
              svg: {
                width: +d3.select(groupElement._groups[0][0].parentNode).attr('width') || svg.width,
                height: +d3.select(groupElement._groups[0][0].parentNode).attr('height') || svg.height
              }
            };

          //groupElement.attr('transform', transform);
          var scale = d3.min([data.svg.height / data.height, data.svg.width / data.width]);

          data.translateX = -(data.x * scale);
          data.translateY = -(data.y * scale);

          groupElement
            .transition()
              .duration(600)
              .attr('transform', 'translate(' + data.translateX + ',' + data.translateY + ') scale(' + scale + ')')
        });
      }
    }
    return vm;
  }
})();
(function() {
  'use strict';

  angular
    .module('storytellingDemo')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($log, $window, d3, $storytelling, ngDialog) {
    var vm = this;
    vm.switchMode = false;
    vm.mobile = false;
    var elWidth = $window.screen.availWidth;
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || elWidth < 620 && elWidth > 0) {
      vm.mobile = true;
    }
    
    angular.element(document).ready(function(){
      angular.element('.scrollspy').scrollSpy();

      if(vm.mobile) {
        ngDialog.open({ template: 'app/main/popUpMobile.html', className: 'ngdialog-theme-default' });
      }
    });

    angular.element($window).bind("scroll", function () {
      var razon = 2.5;
      var windowHeight = angular.element(window).height() / razon;
      var top, difference;

      var circulos = d3.select('.circulos').node();
      top = circulos.getBoundingClientRect().top;
      difference = Math.abs(top - windowHeight);
      if(top > windowHeight * razon) {
        d3.select('#circle_left').style('visibility', 'hidden');
        d3.select('#circle_right').style('visibility', 'hidden');
      }
      if(difference < 5) {
        d3.select('#circle_left').style('visibility', 'visible');
        d3.select('#circle_right').style('visibility', 'visible');
        $storytelling.animateElem('#circle_left', 'fadeInLeft');
        $storytelling.animateElem('#circle_right', 'fadeInRight');
      }
      
      var formula = d3.select('.formula').node();
      top = formula.getBoundingClientRect().top;
      difference = Math.abs(top - windowHeight);
      if (top > windowHeight * razon) {
        d3.select('#img01').style('visibility', 'hidden');
        d3.select('#img02').style('visibility', 'hidden');
        d3.select('#img03').style('visibility', 'hidden');
      }
      if(difference < 5) {
        d3.select('#img01').style('visibility', 'visible');
        d3.select('#img02').style('visibility', 'visible');
        d3.select('#img03').style('visibility', 'visible');
        $storytelling.animateElem('#img01', 'fadeInLeft');
        $storytelling.animateElem('#img02', 'fadeInRight');
        $storytelling.animateElem('#img03', 'fadeInRight');
      }

      d3.selectAll('.animate-scroll').each(function() {
        var el = this;
        var top = d3.select(el).node().getBoundingClientRect().top;
        var windowHeight = angular.element(window).height() / 2;
        var difference = Math.abs(top - windowHeight);
        if (difference < 5) {
          var animationEnds = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
          angular.element(el).addClass('animated shake').one(animationEnds, function () {
            angular.element(el).removeClass('animated undefined shake');
          });
          d3.select(el)
            .style('color', 'black')
              .transition()
              .delay(2000)
                .style('color', '#333');
        }
      });
    });

    /**
     * Scroll to top of the page
     */
    vm.scrollToTop = function() {
      $log.log('ehre');
      $window.scrollTo(0,0);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('storytellingDemo')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('storytellingDemo')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false, d3:false, _:false, scrollWatcher:false */
(function() {
  'use strict';

  angular
    .module('storytellingDemo')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('d3', d3)
    .constant('_', _)
    .constant('scrollWatcher', scrollWatcher);

})();

(function() {
  'use strict';

  angular
    .module('storytellingDemo')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("storytellingDemo").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"row header\"><div class=container><div class=\"col s12\"><div class=wrapper><img class=logo src=assets/images/logo_impunidad.png alt=\"Impunidad Cero\" title=IMPUNIDAD|CERO></div></div></div></div><div class=row><div class=container><div class=\"col s2 hide-on-med-and-down\" style=\"position: fixed; z-index: 2\"><!--div.purple(style=\"width: 65%; padding: 10px;\")img.responsive-img(src=\'assets/images/logo_impunidad.png\', alt=\'Impunidad Cero\', title=\'IMPUNIDAD|CERO\')\n      --><ul class=\"section table-of-contents line_nav\" style=\"background-color: rgba(255,255,255,0.9); width: 71%\"><li><a href=#inicio>1. Inicio</a></li><li><a href=#estados>2. ¿Cómo están los Estados?</a></li><li><a href=#tamano_impunidad>3. ¿Cuál es el tamaño de la impunidad en el estado en el que vives?</a></li><li><a href=#justicia>4. La inversión en procuración de justicia</a></li><li><a href=#efectividad>5. La efectividad</a></li><li><a href=#nayarit>6. El nuevo sistema de justicia y el caso de Nayarit</a></li><li><a href=#no_denuncia>7. La no denuncia</a></li><li><a href=#impunidad>8. El tamaño de la impunidad</a></li></ul></div><div class=\"col s12 m9 offset-m2 center-align\"><div class=row><div class=\"col s12 scrollspy\" id=inicio><div class=section-title><h3>El tamaño de la impunidad en México</h3><h4>En México; no se denuncia el <b>94% </b>de los delitos que se cometen y menos del <b>1% </b>son resueltos.</h4></div><p class=contenido style=\"padding-top: 35px\">En México de cada 100 delitos que se cometen, solo 6.4 se denuncian; de cada 100 delitos que se denuncian, solo 14 se resuelven. Esto quiere decir que la probabilidad de que un delito cometido sea resuelto en nuestro país es tan solo de 0.9%. De este tamaño es la impunidad en México. A estas cifras responde la baja confianza que reportan los ciudadanos hacia los ministerios públicos y procuradurías estatales, solo el 10.3% de las personas dice confiar mucho en estas instituciones.</p><p class=contenido>Cada entidad del país se enfrenta a una problemática diferente en torno a la impunidad. Hay estados que han adoptado buenas prácticas, particularmente alrededor del nuevo sistema de justicia acusatorio y que muestran mejoría en los niveles de impunidad; otros, por el contrario, muestran tendencias preocupantes.</p></div><div class=\"scrollspy col s12\" id=estados><div class=section-title><h3 style=\"padding-top: 35px\">¿Cómo están los estados?</h3></div><p class=contenido style=\"padding-top: 35px\">En Impunidad Cero, en colaboración con Jurimetría, creamos un ranking que incorpora información sobre niveles de denuncia, gasto en procuración de justicia, efectividad en la resolución de investigaciones y averiguaciones previas, entre otros indicadores relevantes, para poder ordenar a las entidades del país según la calidad de su sistema de impartición de justicia. Es importante recalcar que, incluso en las entidades mejor calificadas, la mayoría de los delitos no se denuncian y aún en esa pequeña fracción que sí se denuncia, la mayoría no se resuelve.</p><ranking></ranking></div><div class=\"scrollspy col s12\" id=tamano_impunidad><div class=section-title><h3 style=\"padding-top: 35px\">¿Cuál es el tamaño de la impunidad en el estado en el que vives?</h3></div><p class=contenido>Sabemos cuáles son los estados con una mejor y peor posición en el ranking, pero para ver el tamaño de la impunidad en cada uno de ellos, puedes usar la siguiente gráfica interactiva.</p><p class=instrucciones>INSTRUCCIONES: Selecciona tu entidad para ver cuántos de los delitos que ahí se cometen se denuncian y cuántos se resuelven y compáralo con el desempeño nacional o de otro estado.</p><div class=row><div class=\"col s12\"><div class=\"switch switch-interactive\"><label class=text-switch><span class=black-text>Ver con cifra negra</span> <input type=checkbox ng-model=main.switchMode ng-change=main.switchModeTreemap()><span class=lever></span><span class=denunciados>Ver sin cifra negra</span></label></div></div><div class=\"col s12 m6\"><treemap-esquinado ng-model=main.firstState mode=main.switchMode other=main.secondState></treemap-esquinado></div><div class=\"col s12 m6\"><treemap-esquinado ng-model=main.secondState mode=main.switchMode other=main.firstState></treemap-esquinado></div></div><div class=\"row back_purple\"><div class=\"col s7 contenido\" style=\"color: white; font-size: 16px; text-align: left\">Para construir el ranking, se tomaron en cuenta diversas variables que miden distintos aspectos de la procuración de justicia. Sigue navegando para explorar más detalladamente cada uno de estos aspectos.</div><div class=\"col s5 contenido\" style=\"color: white; font-size: 14px; text-align: left; font-weight: 800\"><ul><li>- La no denuncia</li><li>- La inversión en procuración de justicia</li><li>- La efectividad</li></ul></div></div></div><div class=\"scrollspy col s12\" id=justicia><div class=section-title><h3 style=\"padding-top: 35px\">La inversión en procuración de justicia</h3></div><p class=contenido style=\"padding-top: 35px\">La impunidad en el país es un problema muy grande, pero ¿qué tanto es una prioridad para los estados?</p><p class=contenido>Para que pueda haber una buena procuración de justicia en un estado, es indispensable contar con un número suficiente de personas que lleven a cabo las investigaciones necesarias para esclarecer y castigar los delitos, además de la disponibilidad de suficientes recursos económicos para financiar estas investigaciones.</p><p class=contenido>El presupuesto per cápita en procuración de justicia es el total de dinero que se gasta en ese concepto entre el total de habitantes de una entidad. Es importante comparar los presupuestos per cápita y no los presupuestos totales por la gran variación en población que tienen los estados. La misma lógica impera al usar el total de ministerios por cada 100 mil habitantes. Usar esta métrica permite comparar qué tan bien cubierta está la población, no simplemente el tamaño de la población de un estado.</p><mps-presupuesto></mps-presupuesto><p class=contenido>El presupuesto destinado a procuración de justicia tiene repercusiones que se extienden más allá de la disponibilidad de recursos: está asociado positivamente con la cantidad de personas que dicen confiar en los ministerios públicos o procuradurías estatales.</p><confianza-presupuesto></confianza-presupuesto></div><div class=\"scrollspy col s12\" id=efectividad><h3 class=text_blue>La efectividad</h3><div style=\"border-bottom: solid 4px #112F70\"></div><p class=contenido style=\"padding-top: 35px\">El presupuesto que se destina a la procuración de justicia ayuda a elevar la confianza de las personas en los órganos que se encargan de hacer cumplir la ley, pero de poco sirve contar con su confianza si no hacen su labor efectivamente. Una manera de medir qué tan buenos son los estados en cumplir con su trabajo de procuración de justicia es analizar el total de delitos que se resuelven.</p><p class=contenido>Cuando una persona denuncia un crimen, o cuando se inicia de oficio una investigación, se abre lo que en el sistema anterior se llamaba “averiguación previa” y en el nuevo sistema “carpeta de investigación”. El objetivo de estas investigaciones es determinar si hubo o no un delito y en caso de que sí, establecer quién fue el responsable.</p><p class=contenido>Hay dos maneras de que una averiguación previa o una carpeta de investigación concluyan de manera exitosa:</p><div class=\"row circulos\"><div class=\"col s6 right-align\"><img id=circle_left src=assets/images/circle_left.png style=\"padding-top: 35px\"></div><div class=\"col s6 left-align\"><img id=circle_right src=assets/images/circle_right.png style=\"padding-top: 35px\"></div><div class=\"col s10 offset-s1\"><label style=\"line-height: 1\">* En el Sistema Penal Acusatorio hay una tercera forma de concluir una carpeta de investigación: las autoridades determinan que existe un delito y se aplica un criterio de oportunidad.</label></div></div><p class=contenido>Si tomamos el porcentaje de investigaciones concluidas de manera exitosa de entre el total de investigaciones iniciadas en ese mismo año, más las investigaciones pendientes del año anterior, tenemos el porcentaje de efectividad de resolución de averiguaciones y carpetas de investigación. Usando este porcentaje podemos comparar la efectividad de los estados en cumplir con su trabajo de procuración de justicia.</p><div class=\"row formula\"><div class=\"col s10 offset-s1\" layout=row layout-align=\"center center\"></div><img class=responsive-img id=img01 src=assets/images/img01.png style=\"padding: 30px\"><img id=img02 src=assets/images/img02.png style=\"padding: 30px\"><img id=img03 src=assets/images/img03.png style=\"padding: 30px\"></div><p class=contenido>En promedio, el 6.6% de las investigaciones en el país se resuelven con acción penal y el 3.6% sin acción penal; esto quiere decir que casi el 90% de las investigaciones en el país no se resuelven.</p><national></national><p class=contenido style=\"font-size: 30px; font-weight: 700; line-height: 1.2\">La historia no es la misma para todos los estados, en algunos lugares del país la situación es aún más grave.</p><efectividad></efectividad></div><div class=\"scrollspy col s12\" id=nayarit style=\"overflow-x: hidden\"><div class=\"row black-banner-nayarit absolute left-0 margin-zero\" style=z-index:1><div class=\"col s12 top-spike-background\"></div><div class=\"col s12 right-align black-special-background\"><div class=row><div class=\"col s12 m9 offset-m2 center-align\"><br><img class=responsive-img src=assets/images/mapa.jpg alt=img title=mapa><br><div class=\"right-align col s9\"><a class=\"btn grey darken-1 white-text boton-nayarit\" href=#estados ng-click=$event.stopPropagation()>Volver al ranking</a></div></div></div></div><div class=\"col s12 bottom-spike-background\"></div></div><div class=\"row black-banner-nayarit\" style=\"opacity: 0; z-index: -1\"><div class=\"col s12 top-spike-background\"></div><div class=\"col s12 right-align black-special-background\"><div class=row><div class=\"col s12 m9 offset-m2 right-align\"><br><img class=responsive-img src=assets/images/mapa.jpg alt=img title=mapa><br><a class=\"btn grey darken-1 white-text boton-nayarit\" href=#estados ng-click=$event.stopPropagation()>Volver al ranking</a></div></div></div><div class=\"col s12 bottom-spike-background\"></div></div><p class=contenido style=\"padding-top: 35px\">Vale la pena entender qué está pasando en Nayarit, pues parecería ser uno de los estados que mejor imparten justicia en el país; sin embargo, si escarbamos un poco más profundo, hay razones para pensar que su alta efectividad no está reflejando certeramente lo que ocurre en esa entidad.</p><p class=contenido>En 2008, ante los altos y constantes niveles de impunidad, se reformó el sistema de justicia del país. La reforma implicó la entrada en vigor de un sistema penal acusatorio que incluiría el uso de juicios orales. Se contemplaba que la reforma tardaría 8 años en entrar en vigor por completo en todos los estados del país.</p><p class=contenido>El objetivo del nuevo sistema era mejorar la impartición de justicia en el país y una de las estrategias fundamentales para hacerlo fue la de desahogar a los ministerios públicos de delitos menores para que pudieran concentrar sus recursos en resolver delitos de alto impacto, como homicidios o secuestros.</p><p class=contenido>En 2015, año en el que el INEGI condujo el Censo de Procuración de Justicia Estatal, muy pocos estados habían adoptado por completo el nuevo sistema; en la mayoría el sistema anterior y el sistema nuevo convivían. Esto nos presenta una oportunidad para analizar si el nuevo sistema ha mejorado la efectividad en la resolución de delitos.</p><p class=contenido>En 2015, el <b class=animate-scroll>95% </b>de los casos en Nayarit se seguía resolviendo con el sistema penal tradicional. Esto es problemático porque, bajo el nuevo sistema, esperaríamos que una mayor proporción de los asuntos no graves concluyeran por acción no penal, pues son generalmente delitos menores. Sin embargo, el 69% de las acciones fueron resueltas con acción penal. Esto quiere decir que una gran parte de las acciones penales fueron para sancionar delitos menores, a costa de delitos severos; esto es justamente lo que el nuevo sistema penal acusatorio busca evitar.</p><p class=contenido>Otro aspecto preocupante en Nayarit son las inconsistencias con los datos que reporta esa entidad en el Censo. <b class=animate-scroll>Dos de cada tres consignaciones a tribunales en ese estado se hicieron sin detenido </b>y, aunque se consiguieron <b class=animate-scroll>3,544 órdenes de aprehensión solo 1,702 </b>personas fueron presentadas ante un juez. En los últimos tres años se han reportado sólo alrededor de 220 sentencias penales anuales en esa entidad.</p><p class=contenido>Los datos con los que contamos para evaluar el desempeño de los estados son auto-reportados, por lo que es imposible despejar las incógnitas que presentan estas inconsistencias con información externa.</p></div><div class=\"scrollspy col s12\" id=no_denuncia><div class=section-title><h3 style=\"padding-top: 35px\">La no denuncia</h3></div><p class=contenido style=\"padding-top: 35px\">Que la gran mayoría de los delitos no se castigue no es el único motor de la impunidad en México, también importan los millones de delitos que no se denuncian.</p><p class=contenido>En 2016, 29 millones de delitos no se denunciaron; el 94% del total perpetrado ese año. A la diferencia entre los delitos que ocurren y los que se denuncian se le llama “cifra negra”.</p><p class=contenido>¿Por qué una persona se negaría a denunciar un delito que sufrió? Una posibilidad es que el proceso de denuncia es muy tardado o complicado. Según la Encuesta Nacional de Victimización y Percepción sobre Seguridad Pública (ENVIPE) 2017, casi el 30% de las personas que denunciaron un delito tardaron más de 4 horas en hacerlo; el 29.5% de las mujeres y el 27.8% de los hombres que denunciaron dijo haber recibido un trato “malo” al hacer la denuncia.</p><cifra-negra></cifra-negra></div><div class=\"scrollspy col s12\" id=impunidad><div class=section-title><h3 style=\"padding-top: 35px\">El tamaño de la impunidad</h3></div><p class=contenido style=\"padding-top: 35px\">La impunidad y la ineficacia en la procuración de justicia son un problema nacional, del cual ningún estado está exento. Si bien hay entidades en las que se denuncia una mayor proporción de los delitos y que resuelven adecuadamente un mayor porcentaje de los delitos que se denuncian, en todos hay tasas de efectividad alarmantemente bajas.</p><p class=contenido>Estos inquietantes resultados coexisten con el nuevo sistema de justicia penal acusatorio, el cual, si bien ha introducido buenas prácticas, no ha podido remediar el problema. Es momento de preguntarnos otra vez cómo vamos a consolidar las buenas prácticas y la reforma al sistema penal. Para hacer esto de manera exitosa, la necesidad de observatorios ciudadanos que produzcan información confiable sobre la procuración de justicia en los estados resulta indispensable; para saber qué sí y qué no está funcionando en el nuevo sistema de justicia se necesitan suficientes datos de buena calidad.</p><p></p><div class=row><div class=\"col s12\"><div class=\"center-align pointer\" id=scrollToTop ng-click=main.scrollToTop() role=button tabindex=0><i class=\"material-icons continue-indicator\">keyboard_arrow_up</i><p class=margin-zero>VOLVER AL PRINCIPIO</p></div></div></div></div></div></div></div></div><div class=row><div class=\"col s12 grey lighten-4 footer-banner\"><div class=container><div class=row><div class=\"col s8 right-align\"><p>Información extraida de Zepeda Lecuona, Guillermo Raúl.<br><i>Índice estatal de desempeño de las procuradurías y fiscalías. 2017</i></p></div><div class=\"col s4 left-align\"><a class=download-pdf href=assets/pdf/15_Impunidad_Cero_Ranking_de_procuradurias.pdf target=_blank><div layout=row layout-align=\"start center\"><img class=mr-r-5 src=assets/images/pdf_icon.svg><p>Descarga el reporte original</p></div></a></div></div></div></div></div><div class=row><div class=\"col s12\"><div class=container><div class=row><div class=\"col s12 center-align\"><p>Impunidad Cero | DATA4 | © Todos los derechos reservados | 2017</p></div></div></div></div></div>");
$templateCache.put("app/main/popUpMobile.html","<div class=row><div class=\"col s12 center-align\"><p>Este storytelling está diseñado para navegarse desde una computadora</p></div></div>");
$templateCache.put("app/components/cifraNegra/cifraNegra.html","<div class=row id=cifraNegra><div class=\"col s8\"><div class=outer><div class=\"inner vertical-align\"><div><div class=text_barras style=\"padding-top: 35px\">PORCENTAJE DE DELITOS QUE NO SON DENUNCIADOS POR ENTIDAD</div><div class=grey_line></div><div class=switch ng-show=\"vm.currentSlide == 3\"><label class=text-switch><span style=\"color: #7c1959\">Delitos denunciados</span> <input type=checkbox ng-model=vm.delitos ng-change=vm.switchCifras()><span class=lever></span><span class=black-text>Delitos sin denunciar</span></label></div><div ng-include=vm.svgUrl onload=vm.init()></div></div></div></div></div><div class=\"col s4 left-align\"><div class=\"slide vertical-align\"></div><div class=\"slide vertical-align\"><p class=\"contenido_side left-align\" style=\"padding-right: 40px\">Al igual que en la efectividad de la procuración de justicia, las diferentes entidades del país tienen diferentes niveles de no denuncia, aunque incluso en <b>Baja California Sur</b>, el estado con el menor porcentaje de cifra negra, el porcentaje de delitos no denunciados fue de <b>87% </b>en 2016. La falta de denuncia es un problema nacional, del cual ningún estado está exento.</p></div><div class=\"slide vertical-align\"><p class=\"contenido_side left-align\" style=\"padding-right: 40px\">En <b>Puebla</b>, el <b>95% </b>de los delitos no se denunciaron, y en <b>Guerrero</b>, el estado con la cifra negra más alta, el <b>98% </b>de los delitos que ocurrieron en 2016 no fueron denunciados.</p></div><div class=\"slide vertical-align\"><p class=\"contenido_side left-align\" style=\"padding-right: 40px\">Haz click en el switch para comparar el porcentaje de delitos que sí se denuncian con el de los que no se denuncian en cada entidad del país.</p></div></div></div>");
$templateCache.put("app/components/adolescence/adolescence.html","<div class=row id=adolescence><div class=outer><div class=\"inner col s12 vertical-align\"><div class=zoomable-image id=waldo style=\"background-image: url(\'assets/images/waldo.jpg\')\"></div></div></div></div>");
$templateCache.put("app/components/confianzaPresupuesto/confianzaPresupuesto.html","<div class=row><div class=\"col s8\" id=confianzaPresupuesto><div class=outer><div class=\"inner vertical-align\"><div id=scatter ng-include=\"\'assets/images/svg/scatter_confianzavspresupuesto.svg\'\" onload=vm.init()></div></div></div></div><div class=\"col s4\"><div class=\"slide vertical-align\"><p class=\"contenido_side left-align\" style=\"padding-right: 20px\">Si acomodamos los estados a lo largo, según el porcentaje de sus habitantes que dice confiar “mucho” o “algo” en ministerios públicos o procuradurías estatales, de menor porcentaje a mayor porcentaje</p></div><div class=\"slide vertical-align\"><p class=\"contenido_side left-align\" style=\"padding-right: 20px\">y a lo ancho según el presupuesto per cápita que los estados destinen a labores de procuración de justicia, también de menos a más</p></div><div class=\"slide vertical-align\"><p class=\"contenido_side left-align\" style=\"padding-right: 20px\">Se muestra que destinar más dinero a estas labores está asociado con una ciudadanía que confía más en sus instituciones.</p></div><div class=\"slide vertical-align\"><p class=\"contenido_side left-align\" style=\"padding-right: 20px\">Los estados en la zona verde de la gráfica presentan simultáneamente altos niveles de confianza y de gasto, mientras que los que están en la zona roja presentan bajos niveles de ambos.</p></div><div class=\"slide vertical-align\"><p class=\"contenido_side left-align\">Nuevo León es el estado donde una mayor proporción de sus habitantes dice confiar en estas instituciones, 70% de las personas dijeron confiar “mucho” o “algo” en ellas; es también la tercera entidad con el presupuesto per cápita en procuración de justicia más elevado.</p></div><div class=\"slide vertical-align\"><p class=\"contenido_side left-align\">Por el contrario, el Estado de México es la segunda entidad con porcentaje más bajo de confianza y la octava con menos presupuesto per cápita para la procuración de justicia.</p></div></div></div>");
$templateCache.put("app/components/efectividad/efectividad.html","<div class=row><div class=\"col s12\" id=grafica_efectividad><div class=outer><div class=\"inner vertical-align\"><div class=\"col center-align\" id=chart><div ng-include=\"\'assets/images/svg/efectividad.svg\'\" onload=vm.init()></div></div></div><div class=\"col s4 offset-s8\"><div class=\"slide vertical-align\"></div><div class=\"slide vertical-align left-align\"><div><p class=contenido_side style=\"padding-left: 1px\">En 2015, <b>Durango </b>tenía un porcentaje de solo <b>3% </b>de las averiguaciones resueltas, <b>1% </b>ejerciendo acción penal y <b>2% </b>sin ejercer acción penal. Esto quiere decir que el <b>97% </b>de las investigaciones no fueron concluidas.</p><p class=contenido_side style=\"padding-left: 1px\">Para <b>Veracruz </b>el porcentaje de efectividad total fue de solo <b>5%</b>; <b>3% </b>ejerciendo acción penal y <b>2% </b>sin ejercerla.</p></div></div><div class=\"slide vertical-align left-align\"><div><p class=contenido_side style=\"padding-left: 1px\">En el otro lado del espectro tenemos a estados como <b>San Luis Potosí </b>y <b>Chiapas, </b>que superan por mucho a la media nacional, con porcentajes de efectividad del <b>20%</b>. A pesar de que un porcentaje de <b>20% </b>de efectividad está lejos de ser el ideal, estos estados están muy por arriba de la media nacional.</p><p class=contenido_side style=\"padding-left: 1px\">Incluso en los estados más efectivos, que en 2015 reportaban ya haber adoptado totalmente o casi por completo el nuevo sistema de justicia, la mayoría de las denuncias no se resuelve.</p></div></div></div></div></div></div>");
$templateCache.put("app/components/infancy/infancy.html","<div class=row><div class=\"col s6 m5 offset-m1\"><div class=\"slide vertical-align\"><p class=contenido_side style=\"padding-right: 40px\">Para ver cómo se relacionan estos dos indicadores, acomodamos a los estados del país en dos dimensiones, a lo alto según el presupuesto per cápita que tienen, de menos a más ...</p></div></div><div class=\"col s6\" id=infancy><div class=outer><div class=\"inner vertical-align\"><img class=vertical-align ng-src={{vm.test}} alt=1_mpsvspresupuesto></div></div></div></div>");
$templateCache.put("app/components/national/national.html","<div class=row><div class=\"col s12\" id=national><div class=outer><div class=\"inner vertical-align\"><div><div class=\"col s6 offset-s1\"><img class=responsive-img src=assets/images/impunidad-k.gif></div><div class=\"col s5 left-align contenido_side\"><p>Por cada 100 investigaciones:</p><p class=resueltos ng-show=\"vm.currentSlide &gt;= 0\"><b>3.6 </b>fueron resueltas con acción penal</p><p class=denunciados ng-show=\"vm.currentSlide &gt;= 1\"><b>6.6 </b>fueron resueltas sin acción penal</p><p class=no_denunciados ng-show=\"vm.currentSlide &gt;= 2\">y <b>89.8 </b>no fueron resueltas</p></div><div class=\"col s12 center-align\"><br><img src=assets/images/scrolldown.gif style=\"max-height: 80px\"><!--h1.grey-text.text-lighten-1i.material-icons(style=\"font-size: 42px\") keyboard_arrow_down\n            --></div></div></div></div></div></div>");
$templateCache.put("app/components/mpsPresupuesto/mpsPresupuesto.html","<div class=row><div class=\"col s4\"><div class=\"slide vertical-align\"><p class=\"contenido_side right-align\">Para ver cómo se relacionan estos dos indicadores, acomodamos los estados del país en dos dimensiones, a lo alto según el presupuesto per cápita que tienen, de menos a más</p></div><div class=\"slide vertical-align\"><p class=\"contenido_side right-align\">y a lo ancho según la cantidad de ministerios públicos per cápita que tienen, también de menos a más.</p></div><div class=\"slide vertical-align\"><p class=\"contenido_side right-align\">La situación ideal de un estado sería tener tanto un alto presupuesto per cápita, como suficientes ministerios públicos. Eso colocaría a los puntos que representan a cada estado en la “zona verde” de la gráfica. En la zona roja están los estados con bajos niveles de ambos, mientras que en las áreas blancas están los estados con altos niveles de solo una de estas dos variables.</p></div><div class=\"slide vertical-align\"><p class=\"contenido_side right-align\">En general, a mayor cantidad de ministerios públicos por cada 100 mil habitantes, más recursos se gastan en procuración de justicia; sin embargo, hay estados que son excepcionales en su gasto (o falta de éste).</p></div><div class=\"slide vertical-align\"><p class=\"contenido_side right-align\">Quintana Roo tiene un presupuesto per cápita muy por debajo de la tendencia nacional, gastando solamente $345 anuales por persona en procuración de justicia, a pesar de ser la segunda entidad que más Ministerios Públicos por 100 mil personas tiene.</p></div><div class=\"slide vertical-align\"><p class=\"contenido_side right-align\">Por el contrario, Chihuahua al mismo tiempo que es la entidad que más ministerios públicos tiene por cada 100 mil personas, es la que destina más presupuesto a labores de procuración de justicia.</p></div></div><div class=\"col s8\" id=mpsPresupuesto><div class=outer><div class=\"inner vertical-align\"><div id=scatter ng-include=\"\'assets/images/svg/scatter_mpsvspresupuesto.svg\'\" onload=vm.init()></div></div></div></div></div>");
$templateCache.put("app/components/ranking/ranking.html","<div class=row><div class=\"col s12\" id=ranking><div class=outer><div class=\"inner vertical-align\"><div class=left-align><br><div id=chart ng-include=\"\'assets/images/svg/ranking.svg\'\" onload=vm.init()></div><br><a class=\"btn grey darken-1 white-text boton-nayarit\" href=#nayarit ng-click=$event.stopPropagation()>¿Qué pasa en Nayarit?</a><br><label>Fuente: Índice estatal de desmepeño de las procuradurías y fiscalías, Guillermo Zepeda Lecuona, Impunidad Cero</label></div></div></div></div></div>");
$templateCache.put("app/components/treemapEsquinado/treemapEsquinado.html","<div class=row><div class=\"col s10 offset-s1 treemap\"></div></div><div class=\"center-align select-state\" layout=row layout-align=\"center center\" layout-wrap=nowrap ng-if=!vm.disabled><p class=margin-zero>De los delitos registrados en &nbsp;</p><md-select class=\"estados margin-zero\" ng-model=vm.ngModel ng-change=vm.updateModel()><md-option ng-repeat=\"datum in vm.data\" ng-value=datum>{{datum.entidad}}</md-option></md-select></div><ul type=square ng-if=!vm.disabled><li class=no_denunciados>{{(vm.ngModel.delitos_no_denunciados * 100) | number: 2}}% no fueron denunciados</li><li class=denunciados>{{(vm.ngModel.delitos_si_denunciados * 100) | number :2 }}% fueron denunciados</li><li class=resueltos>y solo {{(vm.ngModel.probabilidad_esclarecimiento * 100) | number:2}}% fueron resueltos</li></ul>");}]);